var nameReg = /^[\u4E00-\u9FA5]{2,7}$/;
function nameValidator(val) {
  return nameReg.test(val);
}

function stuNameValidator(val) {
  return nameReg.test(val);
}

function phoneValidator(val) {
  let reg = /^[1][3,4,6,5,7,8,9][0-9]{9}$/;
  return reg.test(val);
}

function adviserValidator(val) {
  return val.length <= 15;
}

export const rules = {
  nameValidator: [
    { validator: nameValidator, message: "请输入2-7位中文" },
    { required: true, message: "客户姓名必填", trigger: "onBlur" },
  ],
  stuNameValidator: [
    { validator: stuNameValidator, message: "请输入2-7位中文" },
    { required: true, message: "学生姓名必填", trigger: "onBlur" },
  ],
  phoneValidator: [
    { validator: phoneValidator, message: "请输入正确的11位手机号" },
    { required: true, message: "手机号必填", trigger: "onBlur" },
  ],
  sexValidator: [
    { required: true, message: "请选择性别", trigger: "onChange" },
  ],
  gradeValidator: [{ required: true, message: "", trigger: "onBlur" }],
  cityValidator: [{ required: true, message: "", trigger: "onBlur" }],
  adviserValidator: [
    { validator: adviserValidator, message: "请输入推荐人姓名+工号" },
  ],
  productValidator: [{ required: true, message: "", trigger: "onBlur" }],
  subjectValidator: [
    { required: true, message: "请选择意向科目", trigger: "onBlur" },
  ],
};
